import React, { useState } from 'react';
import SubPage from '../components/site/SubPage';
import { PageSection, RuledHeading } from '../components/site/SubPageParts';
import { Modal } from '../components/ui';
import MissionVideo from '../components/site/MissionVideo';

const IMG = '/images/site/company';

/**
 * Investor-facing page: the company film, what the company is for, and how to
 * get in touch.
 *
 * This is the original /leadership page minus the team resumes — those moved to
 * their own Leadership page (slide 67 of the 9-10 deck), which the two nav
 * labels used to share.
 */
const Investors = () => {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <SubPage title="Investors">
      <PageSection className="pt-6">
        {/* The mockup opens straight into the film; the page still needs a
            heading for assistive tech and search. */}
        <h1 className="sr-only">Investors</h1>

        {/* Company film */}
        <div className="flex flex-col items-center justify-center border border-black/25 px-6 py-10 md:py-14">
          <img
            src={`${IMG}/leadership-logo.png`}
            alt="NuVola AI"
            className="h-[54px] w-auto object-contain md:h-[80px]"
          />
          <button
            type="button"
            onClick={() => setVideoOpen(true)}
            className="mt-6 rounded-[6px] border border-black/40 bg-[#8A8A8A] px-8 py-3 text-[17px] text-white transition-colors hover:bg-[#767676] md:text-[19px]"
          >
            Play video &gt;
          </button>
        </div>
      </PageSection>

      <PageSection className="pt-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[minmax(0,38%)_minmax(0,1fr)] md:gap-16">
          <div>
            <RuledHeading>Purpose Driven Design.</RuledHeading>
            <p className="mt-5 text-[16px] leading-relaxed text-black md:text-[19px]">
              We envision a world where everyone has the tools, information, skills and knowledge to
              avoid falling victim to online scammers, fraudsters and digital predators.
            </p>
          </div>

          <div>
            <RuledHeading>About Us.</RuledHeading>
            <div className="mt-5 space-y-6">
              <div>
                <h3 className="text-[18px] font-bold text-black md:text-[22px]">
                  Marketplace Dominance.
                </h3>
                <p className="mt-1 text-[15px] leading-relaxed text-black md:text-[17px]">
                  Overwhelms traditional industry leaders with a market-focused approach that
                  increases market share, outperforms competitors, and establishes an unmatched
                  competitive advantage.
                </p>
              </div>
              <div>
                <h3 className="text-[18px] font-bold text-black md:text-[22px]">
                  Visionary Leadership.
                </h3>
                <p className="mt-1 text-[15px] leading-relaxed text-black md:text-[17px]">
                  Focuses on educating and mobilizing against transnational organized crime
                  syndicates that are stealing tens of billions of dollars, household by household,
                  in sophisticated targeted scams of unprecedented frequency and magnitude.
                </p>
              </div>
            </div>
          </div>
        </div>
      </PageSection>

      <PageSection className="pt-12">
        <div className="border border-black/25 px-6 py-8 md:px-10 md:py-10">
          <h2 className="text-[26px] font-bold text-black md:text-[34px]">Investors Thoughts.</h2>
          <p className="mt-3 text-[15px] leading-relaxed text-black md:text-[18px]">
            If you&rsquo;re looking for a dynamic company building groundbreaking solutions that
            create market dominance, we should talk.
          </p>
          <p className="mt-6 text-[16px] font-bold text-black md:text-[19px]">
            Contact us at{' '}
            <a href="mailto:ir@nuvolaai.com" className="text-[#0A6EA8] underline">
              ir@nuvolaai.com
            </a>{' '}
            to learn more.
          </p>
        </div>
      </PageSection>

      <Modal isOpen={videoOpen} onClose={() => setVideoOpen(false)} size="xlarge" aria-label="Video player">
        {/* Only mounted while the modal is open, so closing it stops playback
            and nothing is fetched for visitors who don't press play. */}
        <MissionVideo />
      </Modal>
    </SubPage>
  );
};

export default Investors;
